// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress__2TO92","done":"done__2KLPA"};